import * as React from 'react';

import { connect } from 'react-redux';

import { Layout, Spin, Row, Col, Card, Table, Button } from 'antd';
import {
	floatToPercentageString,
	getFilterIds,
	getObjectChildrenKeyIds,
	getSpendAnalyticsDrillDownLink,
} from '../../utils/DataFormatterUtils';

import {
	changeFilterValueToArrayOfIds,
	collectAllParentsFromTreeData,
	collectObjectsWithValidPropFromTreeData,
	filterTreeData,
	nullSafeGet,
	nullSafeGetOrElse,
	removeEmptyChildrenFromTreeData,
	sortTreeData,
} from '../../utils/DataAccessUtils';
import { applyLocalAnalyticsTreeFilters } from '../../utils/AnalyticsTreeFilterUtils';
import AnalyticsBreakdownChartSection from '../analytics_breakdown_chart/AnalyticsBreakdownChartSection';
import { fetchWorkBreakdownComparisonSilent } from '../../thunks/analytics_breakdown_comparison_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { withRouter } from 'react-router';
import AnalyticsControlBar from '../analytics_control_bar/AnalyticsControlBar';
import {
	clearWorkProblemTypeFilters,
	updateWorkProblemTypeFilters,
} from '../../actions/work_analytics_actions';
import { debounce } from '../../utils/PerformanceUtils';
import { EmptyState } from '../empty_state/EmptyState';
import {
	fetchWorkOrderCountByProblemTypeWithChildren,
	fetchWorkOrderCountByMonth,
} from '../../thunks/work_analytics_thunks';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
import { CSV_EXPORT_DEFAULTS, FILTER_CONFIG_NAMES, ROLE_TYPES } from '../../utils/DataConstants';
import { ExportToCsv } from 'export-to-csv';
import { INVOICE_STATUS_DISPLAY_NAMES, INVOICE_STATUSES } from '../../constants/InvoiceStatuses';
import { Link } from 'react-router-dom';
import { withUserType } from '../withUserType';
import { exportAnalyticsPageAsPdf } from '../../utils/AnalyticsPdfExportUtils';

const { Content } = Layout;
require('@antv/data-set');
const isEqual = require('fast-deep-equal');
const workOrderCountByProblemTypeChartConfig = {
	xAxisName: 'hierarchyName',
	yAxisName: 'subTotal',
	position: 'hierarchyName*subTotal',
	fillArea: false,
	color: 'hierarchyName',
	cols: {
		fieldName: { alias: 'Problem Type' },
		subTotal: { alias: '# Work Orders' },
	},
	yAxisLabel: {
		textStyle: {
			fontSize: '14',
			fontFamily: 'Roboto',
			fontWeight: 400,
			fill: 'rgba(0,0,0,0.65)',
		},
	},
	xAxisLabel: {
		textStyle: {
			fontSize: '14',
			fontFamily: 'Roboto',
			fontWeight: 400,
			fill: 'rgba(0,0,0,0.65)',
		},
	},
};

const CSV_TITLE = 'Work Analytics by Problem Types';

const exportReduceFunction = (obj) => ({
	name: obj.hierarchyName,
	total: nullSafeGetOrElse('workOrderCounts.subTotal', obj, 0),
	percentage: floatToPercentageString(
		nullSafeGetOrElse('workOrderCounts.percentageOfTotal', obj, 0) / 100
	),
});

class WorkAnalyticsOverviewProblemTypesPage extends React.Component<any, any> {
	state = {
		initialLoading: true,
		search: '',
		filteredTreeData: [],
		problemTypeIds: [],
	};
	debouncedCallback = debounce(
		() => {
			const { fetchWorkOrderCountsByProblemType, fetchWorkOrderCountsByMonth, analytics } =
				this.props;
			const { initialLoading } = this.state;
			const promise1 = fetchWorkOrderCountsByProblemType(analytics.problemTypeFilters);
			const promise2 = fetchWorkOrderCountsByMonth(analytics.problemTypeFilters);
			if (initialLoading) {
				Promise.all([promise1, promise2]).then(() => this.setState({ initialLoading: false }));
			}
		},
		500,
		false
	);

	handlePrint = () =>
		exportAnalyticsPageAsPdf(
			'.analyticsOverviewProblemTypesPage',
			'work-analytics-problem-types-' + new Date().toISOString().slice(0, 10) + '.pdf'
		);

	componentDidMount() {
		const { fetchWorkOrderCountsByProblemType, analytics } = this.props;
		const { initialLoading } = this.state;
		// const promise3 = fetchWorkOrderPriorities({});
		if (analytics.problemTypeFilters.startDate && analytics.problemTypeFilters.endDate) {
			const promise1 = fetchWorkOrderCountsByProblemType(analytics.problemTypeFilters);
			// const promise2 = fetchWorkOrderCountsByMonth(analytics.problemTypeFilters);
			if (initialLoading) {
				Promise.all([promise1]).then(() => this.setState({ initialLoading: false }));
			}
		}
	}

	componentDidUpdate(prevProps) {
		const { analytics } = this.props;
		if (!isEqual(this.props.analytics.problemTypeFilters, prevProps.analytics.problemTypeFilters)) {
			this.debouncedCallback();
		}
	}

	filterByProblemTypeId = (allData) =>
		applyLocalAnalyticsTreeFilters(allData, {
			selectedIds: nullSafeGetOrElse('state.problemTypeIds', this, []),
		});

	getDisplayData = () => {
		const woCountsByProblemType = nullSafeGetOrElse(
			'props.analytics.workOrderCountByProblemType.data',
			this,
			[]
		);

		const displayData = !!this.state.search
			? nullSafeGetOrElse('state.filteredTreeData', this, [])
			: this.filterByProblemTypeId(woCountsByProblemType);

		return sortTreeData(
			displayData,
			(a, b) =>
				parseFloat(nullSafeGetOrElse('workOrderCounts.subTotal', b, 0)) -
				parseFloat(nullSafeGetOrElse('workOrderCounts.subTotal', a, 0))
		);
	};

	normalizeWorkProblemTypeComparisonData = (rawData) => {
		const localFilteredData = applyLocalAnalyticsTreeFilters(rawData || [], {
			selectedIds: nullSafeGetOrElse('state.problemTypeIds', this, []),
			search: nullSafeGetOrElse('state.search', this, ''),
		});
		return collectObjectsWithValidPropFromTreeData(localFilteredData, 'workOrderCounts')
			.map((row) => ({
				...row,
				hierarchyName: row.hierarchyName || row.name,
				fieldName: row.hierarchyName || row.name,
				subTotal: parseFloat(row.workOrderCounts.subTotal),
				percentageOfTotal: parseFloat(row.workOrderCounts.percentageOfTotal),
			}))
			.sort((a, b) => parseFloat(a.subTotal) - parseFloat(b.subTotal));
	};

	onSearch = (e) => {
		const woCountsByProblemType = nullSafeGetOrElse(
			'props.analytics.workOrderCountByProblemType.data',
			this,
			[]
		);

		const search = e.target.value;
		const allData = this.filterByProblemTypeId(woCountsByProblemType);

		this.setState({
			filteredTreeData: !!search
				? filterTreeData(allData, (obj) => obj.name.toLowerCase().includes(search.toLowerCase()))
				: [],
			search,
		});
	};

	removeProblemTypeIdsAndUpdateFilter = (filters) => {
		const { saveProblemTypeFilters } = this.props;
		const { problemTypeIds, ...otherFilters } = filters;
		this.setState({
			problemTypeIds: (problemTypeIds && changeFilterValueToArrayOfIds(problemTypeIds)) || [],
		});
		saveProblemTypeFilters(otherFilters);
	};

	render() {
		const { clearAllProblemTypeFilters, analytics, accountActivated, userType } = this.props;
		const { initialLoading } = this.state;
		const { workOrderCountByProblemType, problemTypeFilters } = analytics;

		const workOrderCountByProblemTypeData = collectObjectsWithValidPropFromTreeData(
			this.getDisplayData(),
			'workOrderCounts'
		)
			.map((el) => ({
				...el,
				hierarchyName: el.hierarchyName || el.name,
				fieldName: el.hierarchyName || el.name,
				subTotal: parseFloat(el.workOrderCounts.subTotal),
				percentageOfTotal: parseFloat(el.workOrderCounts.percentageOfTotal),
			}))
			.sort((a, b) => parseFloat(a.subTotal) - parseFloat(b.subTotal));

		const defaultSortOrder: 'ascend' | 'descend' = 'descend';
		const tooltipTemplate = `
                    <li data-index={index}>
                        <!-- The marker for each record -->
                        <span class="analytics-breakdown-tooltip-marker" style="background-color:{color};"></span>
                        {name}: {value}
                    </li>
        `;

		const workOrderCountByProblemTypeColumns = [
			{
				title: 'Problem Type',
				dataIndex: 'name',
				key: 'name',
				render: (text) => (
					<Ellipsis tooltip={true} style={{ display: 'inline' }} length={28}>
						{text}
					</Ellipsis>
				),
			},
			{
				title: '# Work Orders',
				dataIndex: ['workOrderCounts', 'subTotal'],
				key: 'totalSpend',
				defaultSortOrder: defaultSortOrder,
				sorter: (a, b) =>
					nullSafeGetOrElse('workOrderCounts.subTotal', a, 0) -
					nullSafeGetOrElse('workOrderCounts.subTotal', b, 0),
				render: (amount) => amount,
			},
			{
				title: '% of Total',
				dataIndex: ['workOrderCounts', 'percentageOfTotal'],
				key: 'percentageOfTotal',
				render: (num) => floatToPercentageString((num || 0) / 100),
				width: 100,
			},
			{
				title: '',
				render: (data) => {
					const filters = {
						...problemTypeFilters,
						problemTypeIds: getObjectChildrenKeyIds(data),
					};
					return (
						<Link
							to={getSpendAnalyticsDrillDownLink(
								userType,
								getFilterIds(filters, FILTER_CONFIG_NAMES.CREATED_AT),
								'workOrders'
							)}
							target="_blank"
						>
							<Button type={'link'}>
								See Details <i className="icons8-font icons8-external-link ml-2 inline-block" />
							</Button>
						</Link>
					);
				},
				width: 100,
			},
		];

		return (
			<Content
				className="analyticsOverviewProblemTypesPage"
				style={{ padding: '0 0.5em', position: 'relative' }}
			>
				{/*<BackTop/>*/}
				{accountActivated ? (
					[
						<Row key={1} style={{ margin: '0.5em -8px' }} gutter={16}>
							<Col span={24}>
								<div
									style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
								>
									<div></div>
									<AnalyticsControlBar
										updateFilters={this.removeProblemTypeIdsAndUpdateFilter}
										clearFilters={clearAllProblemTypeFilters}
										supplierFacilityIds={problemTypeFilters.supplierFacilityIds}
										problemTypeIds={this.state.problemTypeIds}
										locationIds={problemTypeFilters.locationIds}
										brandIds={problemTypeFilters.brandIds}
										startDate={problemTypeFilters.startDate}
										endDate={problemTypeFilters.endDate}
										isPM={problemTypeFilters.isPM}
										woPriorityIds={problemTypeFilters.woPriorityIds}
										showSearch
										search={this.state.search}
										onSearch={this.onSearch}
										showPrint={true}
										onPrint={this.handlePrint}
										filterConfig={{
											workCompletedAt: true,
											problemTypes: true,
											workOrderPriorities: true,
											isPM: true,
											brandIds: true,
										}}
									/>
								</div>
							</Col>
						</Row>,

						<>
							<Row key={2} style={{ margin: '0.5em -8px' }} gutter={16}>
								<Col span={24}>
									<Card>
										<Spin spinning={workOrderCountByProblemType.loading || initialLoading}>
											{this.getDisplayData().length > 0 ? (
												<Table
													columns={workOrderCountByProblemTypeColumns}
													rowKey={(el) => el.id}
													dataSource={removeEmptyChildrenFromTreeData(this.getDisplayData())}
													expandable={{
														...(!!this.state.search && {
															expandedRowKeys: collectAllParentsFromTreeData(
																this.state.filteredTreeData,
																(_) => _.id
															),
														}),
													}}
												/>
											) : (
												<EmptyState
													height={120}
													headline={'No work orders found'}
													body={
														<div style={{ maxWidth: 488, textAlign: 'center' }}>
															We didn't find any work orders. Try changing your filters or expanding
															the selected time period.
														</div>
													}
												/>
											)}
										</Spin>
									</Card>
								</Col>
							</Row>
							<Row>
								<Col span={24}>
									<AnalyticsBreakdownChartSection
										loading={workOrderCountByProblemType.loading || initialLoading}
										filters={problemTypeFilters}
										userType={userType}
										primaryChartRows={workOrderCountByProblemTypeData}
										categoryField="hierarchyName"
										fetchComparisonData={(params) =>
											fetchWorkBreakdownComparisonSilent(
												'work_order_counts_by_problem_type_with_children'
											)(userType)(params)
										}
										normalizeComparisonData={this.normalizeWorkProblemTypeComparisonData}
										localFilterRevision={`${this.state.search}|${(
											this.state.problemTypeIds || []
										).join(',')}`}
										cols={workOrderCountByProblemTypeChartConfig.cols}
										formatValueLabel={(val) => String(val)}
										valueAxisTitle="# Work Orders"
										exportTitle={CSV_TITLE}
										exportCategoryLabel="Problem Type"
										exportValueLabel="Total Workorders"
										formatExportValue={(amount) => amount}
										singleTooltipItemTemplate={tooltipTemplate}
										chartTitleLabel="Work Orders by Problem Type"
										chartTitleValue={`${workOrderCountByProblemTypeData.reduce(
											(sum, row) => sum + (parseFloat(row.subTotal as any) || 0),
											0
										)} Work Orders`}
									/>
								</Col>
							</Row>
						</>,
					]
				) : (
					<EmptyState
						graphic={
							<img
								style={{ marginBottom: 8 }}
								alt="You haven't activated your account yet."
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/letter owl.svg"
							/>
						}
						headline={"You haven't activated your account yet."}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 560, marginBottom: 16 }}>
									Please check your email. We sent you a note with an activation link.
								</div>
							</div>
						}
					/>
				)}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	accountActivated: state.session.accountActivated,
	workOrderPriorities: state.work_order_priorities,
	currentUser: state.session.currentUser,
	analytics: state.work_analytics,
	userType: (state as any).session.userType,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	saveProblemTypeFilters: (filters) => dispatch(updateWorkProblemTypeFilters(filters)),
	clearAllProblemTypeFilters: (filters) => dispatch(clearWorkProblemTypeFilters()),
	fetchWorkOrderPriorities: (params, filters = null, pagination = null, sorting = null) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier.read(params, filters, pagination, sorting)
				: workOrderPrioritiesRestCrudThunksForBuyer.read(params, filters, pagination, sorting)
		),
	fetchWorkOrderCountsByProblemType: (params, filters = null, pagination = null, sorting = null) =>
		dispatch(
			fetchWorkOrderCountByProblemTypeWithChildren(ownProps.userType)(
				params,
				filters,
				pagination,
				sorting
			)
		),
	fetchWorkOrderCountsByMonth: (params, filters = null, pagination = null, sorting = null) =>
		dispatch(fetchWorkOrderCountByMonth(ownProps.userType)(params, filters, pagination, sorting)),
});

export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkAnalyticsOverviewProblemTypesPage))
);
